import { render } from "./New.vue?vue&type=template&id=656a7514&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-656a7514"

export default script